/** Inject Cloudinary transformations into a CDN URL for auto-format + auto-quality + width.
 * Examples:
 *   in:  https://res.cloudinary.com/dwobukvxm/image/upload/v123/crm/uploads/x.jpg
 *   out: https://res.cloudinary.com/dwobukvxm/image/upload/f_auto,q_auto,w_800/v123/crm/uploads/x.jpg
 * Non-Cloudinary URLs are returned unchanged. */
export const cldOptimize = (url, transform = 'f_auto,q_auto,w_800') => {
  if (!url || typeof url !== 'string') return url;
  if (!url.includes('res.cloudinary.com')) return url;
  if (!url.includes('/image/upload/') && !url.includes('/video/upload/')) return url;
  if (url.match(/\/upload\/(f_auto|q_auto|w_|h_|c_)/)) return url;
  return url.replace(/\/upload\//, `/upload/${transform}/`);
};

/** Compact thumbnail (e.g., catalog list rows, product grid cards). 200px wide, smart crop. */
export const cldThumb = (url, size = 200) =>
  cldOptimize(url, `c_fill,g_auto,w_${size},h_${size},f_auto,q_auto`);
